import { getInsightsHabits } from '@griply/utils';
import { useHabits } from 'features/tasks';
import { useTimeframeTime } from 'features/user';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useInsightsHabits = () => {
  const user = useUser();
  const habits = useHabits();
  const { startDate, endDate } = useTimeframeTime();

  return useMemo(
    () =>
      getInsightsHabits({
        habits,
        insightsSettings: user?.settings?.insights,
        habitSorting: user?.settings?.habitSorting ?? [],
        periodStart: startDate,
        periodEnd: endDate,
      }),
    [
      habits,
      user?.settings?.habitSorting,
      user?.settings?.insights,
      startDate,
      endDate,
    ],
  );
};
